(function () {

    angular.module('tmx-app').controller('processDesignerEditCtrl', ['$stateParams', '$state', 'ProcessDesignerService', 'APP_CONSTANTS', 'LoanApplicationService', 

        function ProcessDesignerEditCtrl($stateParams,$state, ProcessDesignerService, APP_CONSTANTS,LoanApplicationService) {

            var workflowdesignerVM = this;
            var wfdesigner = undefined;
            var processid = undefined;       
            workflowdesignerVM.readonly = false;

            if($state.current.name.indexOf(".add")>0) {
                workflowdesignerVM.readonly = false;

            }
            else{
                workflowdesignerVM.WorkflowSchemeCode = $stateParams.Id;        
                workflowdesignerVM.readonly = true;
            }   

            workflowdesignerVM.products = [];
            workflowdesignerVM.loadedProducts=[];
            ProcessDesignerService.getByAction('ActiveLov', true, 'get').then(function (response) {
                workflowdesignerVM.products = response.data;
            });

            LoanApplicationService.getByAction('Workflow/ProductMapping?schemeCode='+workflowdesignerVM.WorkflowSchemeCode, true, 'get').then(function (response) {
                for(var i=0; i<response.data.length; i++){
                    response.data[i].HiddenValue=response.data[i].ProductId;
                }
            
                workflowdesignerVM.selectedProduct = response.data;
                workflowdesignerVM.loadedProducts=response.data;
            });

            workflowdesignerVM.url = APP_CONSTANTS.backend + "loanapplication/workflow/Designer/";

            workflowdesignerVM.save = function () {

                wfdesigner.schemecode = workflowdesignerVM.WorkflowSchemeCode;
                wfdesigner.productId = workflowdesignerVM.selectedProduct;
                var err = wfdesigner.validate();
                if (err != undefined && err.length > 0) {
                    alert(err);
                }
                else {
                    wfdesigner.save();

                    var comparewith={};

                    for(var l=0; l<workflowdesignerVM.loadedProducts.length; l++){
                        comparewith[workflowdesignerVM.loadedProducts[l].ProductId]=workflowdesignerVM.loadedProducts[l].WorkflowSchemeCode;
                    }

                
                    var productList = [];
                    for(var i=0; i<workflowdesignerVM.selectedProduct.length; i++){

                        productList.push(
                            {
                                "WorkflowSchemeCode":workflowdesignerVM.WorkflowSchemeCode,
                                "ProductId":workflowdesignerVM.selectedProduct[i].HiddenValue
                            }
                        )
                    }

                    LoanApplicationService.getByAction("/Workflow/ProductMapping",false,"post",productList).then(function(response){
                        return response;
                    });
                }
            };

            workflowdesignerVM.wfdesignerRedraw = function () {
                var width = $('#workflow-main-div').css("width");
                width = width.replace('px', '');
                width = width - 58;
                var height = $('#workflow-main-designer').css("height");
                height = height.replace('px', '');
                height = height - 58;

                var isreadonly = false;
                if (processid != undefined && processid != '')
                    isreadonly = true;

                // eslint-disable-next-line no-undef
                wfdesigner = new WorkflowDesigner({
                //name: 'simpledesigner',
                    name: 'LoanApplicationDesinger',
                    apiurl: workflowdesignerVM.url,
                    renderTo: 'wfdesigner',
                    imagefolder: 'assets/images/WorkflowDesigner/',
                    readonly: isreadonly,
                    graphwidth: width,
                    graphheight: height
                });
            

                var p = { schemecode: workflowdesignerVM.WorkflowSchemeCode, processid: processid, readonly: isreadonly };
                if (wfdesigner.exists(p))
                    wfdesigner.load(p);
                else
                    wfdesigner.create();
            }
            
            workflowdesignerVM.wfdesignerRedraw();
            angular.element('#wfdesigner').bind('mousewheel',function(e){e.preventDefault()});
        }]);
})();